
import React from 'react';
import { MultiValue, useEntity} from 'react-admin-base';
import { SingleFilePicker, EntityEditor, ImagePicker } from 'react-admin-base-bootstrap';
import {Col, Container, Input, Row, FormText} from "reactstrap";
import MultiSelectCheck from "../Components/MultiSelectCheck";
import { Step, StepLayout } from "../Components/Step";

import JobStatuses from '../data/job_status.json';
import CommTools from '../data/commtools.json';
import Countries from '../data/countries.json';
import Levels from '../data/levels.json';
import SelfAsses from "../Components/SelfAsses";
import Topics from "../data/topics.json";
import Sports from "../data/sports.json";
import {useUser} from "../Components/UserProvider";
import LogoutBox from "../Components/LogoutBox";
import Field from "../Components/Field";
import SingleSelectCheck from "../Components/SingleSelectCheck";
import {LanguageSelect} from "../Components/Selects";
import FancyEntityEditor from '../Components/FancyEntityEditor';
import { FormattedMessage } from 'react-intl';

const gender = {
    '1': 'Male',
    '2': 'Female'
};

const types = {
    '1': 'Profit',
    '2': 'Non-Profit',
    '3': 'Social Enterprise'
}

function StaticSelect({ value, onChange, values }) {
    return <Input type="select" value={value || ''} onChange={a => onChange(a.currentTarget.value || null)}>
        <option>Please select</option>
        { Object.entries(values).map(a => <option value={a[0]}>{a[1]}</option>) }
    </Input>;
}

export default function Mentee() {
    const user = useUser();
    return <MenteeEdit
        id={user.id}
    />
}

export function MenteeEdit({id}) {
    const entity = useEntity('/mentee', id, { user: {} });
    const [ data, setData,, loading ] = entity;
    
    return <FancyEntityEditor entity={entity}>
        <StepLayout saveOnLastStep={!data.user.id}>
            <Step translate="PROFILE_INFORMATION">
                <Field translate="PROFILE_PHOTO" type="required">
                    <ImagePicker
                        value={data.user.avatar || ''}
                        onChange={a => setData({ user: { ...(data.user || {}), avatar: a } })}
                        width="512"
                        height="512"
                        type="png"
                    />
                </Field>
                <Field translate="GENDER" type="required">
                    <StaticSelect
                        value={(data.gender || '').toString()}
                        onChange={a => setData({ gender: +a })}
                        values={gender}
                    />
                </Field>
                <Field translate="BIRTH_YEAR" type="required|numberic">
                    <Input
                        type="text"
                        value={data.birth_year || ''}
                        onChange={a => setData({ birth_year: a.currentTarget.value })}
                    />
                </Field>

                <Field translate="YOUR_LOCATION" type="required">
                    <StaticSelect
                        value={data.location_id}
                        onChange={a => setData({ location_id: a })}
                        values={Countries}
                    />
                </Field>

                <Field translate="PHONE_NUMBER">
                    <Input
                        type="text"
                        value={data.phone || ''}
                        onChange={a => setData({ phone: a.currentTarget.value })}
                    />
                </Field>
                <Field translate="LANGUAGES_SPOKEN" type="required">
                    <LanguageSelect
                        value={data.language_ids}
                        onChange={a => setData({ language_ids: a })}
                        isMulti
                    />
                </Field>
                <Field translate="LINKEDIN_PROFILE" type="url">
                    <Input
                        type="text"
                        value={data.linkedin_profile || ''}
                        onChange={a => setData({ linkedin_profile: a.currentTarget.value })}
                    />
                </Field>
            </Step>
            <Step translate="VENTURE">
                <Field translate="VENTURE_IDEA">
                    <StaticSelect
                        value={data.type}
                        onChange={a => setData({ type: a })}
                        values={types}
                    />
                </Field>

                <Field translate="VENTURE_NAME">
                    <Input
                        type="text"
                        value={data.venture_name || ''}
                        onChange={a => setData({ venture_name: a.currentTarget.value })}
                    />
                </Field>

                <Field translate="JOB_TITLE">
                    <Input
                        type="text"
                        value={data.position || ''}
                        onChange={a => setData({ position: a.currentTarget.value })}
                    />
                </Field>

                <Field translate="VENTURE_WEBSITE" type="url">
                    <Input
                        type="text"
                        value={data.venture_website || ''}
                        onChange={a => setData({ venture_website: a.currentTarget.value })}
                    />
                </Field>

                <Field translate="STARTUP_SUMMARY">
                    <Input
                        type="textarea"
                        rows={6}
                        value={data.about || ''}
                        onChange={a => setData({ about: a.currentTarget.value })}
                    />
                    <FormText><FormattedMessage id="STARTUP_SUMMARY_DESC" /></FormText>
                </Field>
            </Step>

            <Step translate="STAGE">
                <Field translate="FOCUS_AREAS_MENTEE">
                    <SingleSelectCheck
                        id="levels"
                        value={data.focus_area_id || ''}
                        onChange={a => setData({ focus_area_id: a })}
                        fields={Levels}
                    />
                </Field>

                <Field translate="VENTURE_LAUNCH_DATE">
                    <Input
                        type="date"
                        value={data.venture_launch_date || ''}
                        onChange={a => setData({ venture_launch_date: a.currentTarget.value })}
                    />
                </Field>

                <Field translate="VENTURE_FIELD_OF_ACTIVITY">
                    <MultiSelectCheck
                        id="activity1"
                        value={data.assessment_ids}
                        onChange={a => setData({ assessment_ids: a })}
                        fields={Sports}
                    />
                </Field>

                <Field translate="VENTURE_ASSESMENT">
                    <MultiSelectCheck
                        id="activity2"
                        value={data.assessment_ids}
                        onChange={a => setData({ assessment_ids: a })}
                        fields={Topics}
                    />
                </Field>
            </Step>
        </StepLayout>
    </FancyEntityEditor>;
}
